import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Directive({ standalone: false,
  selector: '[docDebounceClick]'
})
export class DebounceClickDirective implements OnInit, OnDestroy {
  @Input() debounceTime = 1000;
  @Output() debounceClick = new EventEmitter();
  private clicks = new Subject();
  private subscription!: Subscription;

  ngOnInit() {
    this.subscription =
      this.clicks.pipe(throttleTime(this.debounceTime))
      .subscribe(e => this.debounceClick.emit(e));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  clickEvent(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [DebounceClickDirective],
  exports: [DebounceClickDirective],
})
export class DebounceClickDirectiveModule {}